"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValueComboboxLinkControl = void 0;
const react_1 = __importDefault(require("react"));
const controls_1 = require("../../..");
const valueComboboxLinkControlRenderer_styles_1 = require("./valueComboboxLinkControlRenderer.styles");
function createValueComboboxLinkControl({ textGetter = (value) => `${value}`, options: customOptions } = {}) {
    return function ValueComboboxLinkControlRenderer({ disabled, options, value, onValueChange }) {
        const valueGetter = ({ value }) => value;
        const titleGetter = ({ value, title }) => title || textGetter(value);
        const controlRenderer = (0, controls_1.createLinkControl)();
        const placeholder = `${value}`;
        return (react_1.default.createElement(valueComboboxLinkControlRenderer_styles_1.StyledValueComboboxLinkControlRendererCombobox, { value: value, data: customOptions || options, disabled: disabled, valueGetter: valueGetter, textGetter: titleGetter, controlRenderer: controlRenderer, onChange: onValueChange, placeholder: placeholder }));
    };
}
exports.createValueComboboxLinkControl = createValueComboboxLinkControl;
//# sourceMappingURL=valueComboboxLinkControlRenderer.js.map